// extracted by mini-css-extract-plugin
module.exports = {"removeComponentIcon":"projects_removeComponentIcon__wz_if","tasksNumberAndDurationTimeRoot":"projects_tasksNumberAndDurationTimeRoot__2m5TK"};